/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Rotate_ConfirmInputs */

const cs_xml_feed_rotate_confirm = /** @type {(inputs: Xml_Feed_Rotate_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit klíč feedu? Stará adresa přestane okamžitě fungovat.`)
};

const en_xml_feed_rotate_confirm = /** @type {(inputs: Xml_Feed_Rotate_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate the feed key? The old URL will stop working immediately.`)
};

/**
* | output |
* | --- |
* | "Rotate the feed key? The old URL will stop working immediately." |
*
* @param {Xml_Feed_Rotate_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_rotate_confirm = /** @type {((inputs?: Xml_Feed_Rotate_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Rotate_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_rotate_confirm(inputs)
	return cs_xml_feed_rotate_confirm(inputs)
});